import type { Reference } from "@/components/message/message-list";
import { getFileBadge } from "@/components/ui/file-type-indicator";

/** URL 을 못 읽거나 파비콘을 못 받는 출처에 쓰는 기본 아이콘 */
export const FALLBACK_FAVICON = "/images/answer_source_icon.svg";

/** 한 번에 보여줄 파비콘 최대 개수. 넘치면 앞에서부터 자른다 */
const MAX_FAVICONS = 3;

export const getFaviconUrl = (url: string) => {
  try {
    const domain = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=16`;
  } catch {
    return FALLBACK_FAVICON;
  }
};

export const getSourceKey = (refs: Reference[]) =>
  [...(refs ?? [])]
    .map((r) => r.reference_number)
    .sort((a, b) => a - b)
    .join(",");

/**
 * 웹 출처의 파비콘 목록. 도메인 기준으로 중복을 없앤다.
 * 파일 출처는 확장자 배지가 대신하므로 건너뛰고, URL 을 못 읽는 나머지는 기본 아이콘 하나로 묶는다.
 */
export const getSourceFavicons = (refs: Reference[]) => {
  const seen = new Set<string>();
  const favicons: string[] = [];

  for (const ref of refs ?? []) {
    if (favicons.length >= MAX_FAVICONS) break;
    if (getFileBadge(ref.title)) continue;

    let key: string;
    try {
      key = new URL(ref.url).hostname;
    } catch {
      key = FALLBACK_FAVICON;
    }
    if (seen.has(key)) continue;
    seen.add(key);
    favicons.push(getFaviconUrl(ref.url));
  }
  return favicons;
};
